import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

// create a new user
const CREATE_USER_SCOPE = 'CREATE_USER';
export const CREATE_USER = createSubmitType(CREATE_USER_SCOPE);
export const CREATE_USER_SUCCESS = createSuccessType(CREATE_USER_SCOPE);
export const CREATE_USER_ERROR = createErrorType(CREATE_USER_SCOPE);
export const CREATE_USER_LOADING = createLoadingType(CREATE_USER_SCOPE);

const AUTHENTICATE_USER_SCOPE = 'AUTHENTICATE_USER';
export const AUTHENTICATE_USER = createSubmitType(AUTHENTICATE_USER_SCOPE);
export const AUTHENTICATE_USER_SUCCESS = createSuccessType(
  AUTHENTICATE_USER_SCOPE,
);
export const AUTHENTICATE_USER_ERROR = createErrorType(AUTHENTICATE_USER_SCOPE);
export const AUTHENTICATE_USER_LOADING = createLoadingType(
  AUTHENTICATE_USER_SCOPE,
);

const INIT_USER_SCOPE = 'INIT_USER';
export const INIT_USER = createSubmitType(INIT_USER_SCOPE);
export const INIT_USER_SUCCESS = createSuccessType(INIT_USER_SCOPE);
export const INIT_USER_ERROR = createErrorType(INIT_USER_SCOPE);

const REFRESH_TOKENS_SCOPE = 'REFRESH_TOKENS_SCOPE';
export const REFRESH_TOKENS = createSubmitType(REFRESH_TOKENS_SCOPE);
export const REFRESH_TOKENS_SUCCESS = createSuccessType(REFRESH_TOKENS_SCOPE);
export const REFRESH_TOKENS_ERROR = createErrorType(REFRESH_TOKENS_SCOPE);

export const RESET_USER = 'RESET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

// forgotten password
const PASSWORD_FORGOTTEN_REQUEST_SCOPE = 'PASSWORD_FORGOTTEN_REQUEST';
export const PASSWORD_FORGOTTEN_REQUEST = createUpdateType(
  PASSWORD_FORGOTTEN_REQUEST_SCOPE,
);
export const PASSWORD_FORGOTTEN_REQUEST_SUCCESS = createSuccessType(
  PASSWORD_FORGOTTEN_REQUEST_SCOPE,
);
export const PASSWORD_FORGOTTEN_REQUEST_ERROR = createErrorType(
  PASSWORD_FORGOTTEN_REQUEST_SCOPE,
);

export const PASSWORD_FORGOTTEN_REQUEST_LOADING = createLoadingType(
  PASSWORD_FORGOTTEN_REQUEST_SCOPE,
);

// reset password authentication
const RESET_PASSWORD_REQUEST_SCOPE = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST = createUpdateType(
  RESET_PASSWORD_REQUEST_SCOPE,
);
export const RESET_PASSWORD_REQUEST_SUCCESS = createSuccessType(
  RESET_PASSWORD_REQUEST_SCOPE,
);
export const RESET_PASSWORD_REQUEST_ERROR = createErrorType(
  RESET_PASSWORD_REQUEST_SCOPE,
);

// generate token
const GENERATE_TOKEN_SCOPE = 'GENERATE_TOKEN';
export const GENERATE_TOKEN = createSubmitType(GENERATE_TOKEN_SCOPE);
export const GENERATE_TOKEN_SUCCESS = createSuccessType(GENERATE_TOKEN_SCOPE);
export const GENERATE_TOKEN_ERROR = createErrorType(GENERATE_TOKEN_SCOPE);
export const GENERATE_TOKEN_LOADING = createLoadingType(GENERATE_TOKEN_SCOPE);

// basic account
const BASIC_ACCOUNT = 'BASIC_ACCOUNT';
export const GET_BASIC_ACCOUNT = createFetchType(BASIC_ACCOUNT);
export const GET_BASIC_ACCOUNT_ERROR = createErrorType(BASIC_ACCOUNT);
export const GET_BASIC_ACCOUNT_SUCCESS = createSuccessType(BASIC_ACCOUNT);
export const GET_BASIC_ACCOUNT_LOADING = createLoadingType(BASIC_ACCOUNT);

// set logonUid
export const SET_LOGON_UID = createSuccessType('SET_LOGON_UID');

// fetch usernames
const FETCH_USERNAMES = 'FETCH_USERNAMES';
export const USERNAMES_FETCH = createFetchType(FETCH_USERNAMES);
export const USERNAMES_FETCH_ERROR = createErrorType(FETCH_USERNAMES);
export const USERNAMES_FETCH_SUCCESS = createSuccessType(FETCH_USERNAMES);
export const USERNAMES_FETCH_LOADING = createLoadingType(FETCH_USERNAMES);

// CREATE PLAIN USER

const CREATE_PLAIN_USER_SCOPE = 'CREATE_PALIN_USER';
export const CREATE_PLAIN_USER = createSubmitType(CREATE_PLAIN_USER_SCOPE);
export const CREATE_PLAIN_USER_SUCCESS = createSuccessType(
  CREATE_PLAIN_USER_SCOPE,
);
export const CREATE_PLAIN_USER_ERROR = createErrorType(CREATE_PLAIN_USER_SCOPE);
export const CREATE_PLAIN_USER_LOADING = createLoadingType(
  CREATE_PLAIN_USER_SCOPE,
);

// encrypt V2 user email
const ENCRYPTED_EMAIL_SCOPE = 'ENCRYPTED_EMAIL_FETCH';
export const ENCRYPTED_EMAIL_FETCH = createFetchType(ENCRYPTED_EMAIL_SCOPE);
export const ENCRYPTED_EMAIL_FETCH_SUCCESS = createSuccessType(
  ENCRYPTED_EMAIL_SCOPE,
);
export const ENCRYPTED_EMAIL_FETCH_ERROR = createErrorType(
  ENCRYPTED_EMAIL_SCOPE,
);
export const ENCRYPTED_EMAIL_FETCH_LOADING = createLoadingType(
  ENCRYPTED_EMAIL_SCOPE,
);

// decrypt V2 user email
const DECRYPTED_EMAIL_SCOPE = 'DENCRYPTED_EMAIL_FETCH';
export const DECRYPTED_EMAIL_FETCH = createFetchType(DECRYPTED_EMAIL_SCOPE);
export const DECRYPTED_EMAIL_FETCH_SUCCESS = createSuccessType(
  DECRYPTED_EMAIL_SCOPE,
);
export const DECRYPTED_EMAIL_FETCH_ERROR = createErrorType(
  DECRYPTED_EMAIL_SCOPE,
);
export const DECRYPTED_EMAIL_FETCH_LOADING = createLoadingType(
  DECRYPTED_EMAIL_SCOPE,
);
